import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'

import Checklist from '../../../../components/checklist'
import DoodleBackground from '../../../../components/doodle-background'
import { Column, Row } from '../../../../components/layout-row'
import Testimonal from '../../../../components/testimonal'
import Textblock from '../../../../components/textblock'

import { Gallery, Stories } from '../../../../sections/instagram'

import styles from './features.module.scss'
import imgThumbsUp from './career-thumbs-up.png'
import imgDeveloper from './career-developer.jpg'

const Features = () => (
  <div className={styles.root}>
    <Row>
      <Column first>
        <Stories />
      </Column>
      <Column limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="När du blir en del av vårt fantastiska team får du&nbsp;vara med på en resa där bara du sätter gränserna. Hos oss kommer du växa och utvecklas till en riktig stjärna."
              id="career.features.anything-is-possible-description"
            />
          }
          extra={
            <Testimonal
              imgSrc={imgDeveloper}
              jobTitle={<FormattedMessage defaultMessage="fullstack-utvecklare" id="career.features.testimonal-name" />}
              name="John"
              text={
                <FormattedHTMLMessage
                  defaultMessage="På Dooer går det snabbt. Och då menar jag riktigt snabbt. Dessutom har vi stora resurser för utveckling, som <span class='hidden-xs'>teknik-<br />freak</span><span class='visible-xs'>teknikfreak</span> är det grymt!"
                  id="career.features.testimonal"
                />
              }
            />
          }
          subTitle={
            <FormattedMessage
              defaultMessage="Du kommer kunna ta dig dit du vill"
              id="career.features.anything-is-possible-subtitle"
            />
          }
          title={
            <FormattedMessage
              defaultMessage="Allt är möjligt. Det är upp till dig."
              id="career.features.anything-is-possible-title"
            />
          }
        />
      </Column>
    </Row>

    <Row top="second">
      <Column first limitWidth>
        <Textblock
          description={
            <FormattedMessage
              defaultMessage="Hos oss får du det där lilla extra som sätter guldkant på vardagen. Schyssta&nbsp;villkor, personlig utveckling och massa roligt tillsammans med&nbsp;hela teamet. Häng&nbsp;med!"
              id="career.features.room-for-everyone-description"
            />
          }
          extra={
            <Checklist
              horizontal
              items={[
                <FormattedMessage defaultMessage="Branschledande lön" id="career.features.list-salaries" key="1" />,
                <FormattedMessage
                  defaultMessage="Superbra privat sjukförsäkring"
                  id="career.features.list-insurance"
                  key="2"
                />,
                <FormattedMessage defaultMessage="5000:- friskvårdsbidrag" id="career.features.list-benefit" key="3" />,
                <FormattedMessage
                  defaultMessage="Förmånlig tjänstepension"
                  id="career.features.list-pension"
                  key="4"
                />,
                <FormattedMessage
                  defaultMessage="Kylar och hyllor fulla av energi"
                  id="career.features.list-energy"
                  key="5"
                />,
                <FormattedMessage defaultMessage="Den teknik som passar dig" id="career.features.list-tech" key="6" />,
                <FormattedMessage
                  defaultMessage="Snabb personlig utveckling"
                  id="career.features.list-growth"
                  key="7"
                />,
                <FormattedMessage
                  defaultMessage="Eget ansvar och tydliga mål"
                  id="career.features.list-responsibilities"
                  key="8"
                />,
                <FormattedMessage
                  defaultMessage="1000:- i hörlursbidrag"
                  id="career.features.list-headphones"
                  key="9"
                />,
                <FormattedMessage
                  defaultMessage="Mycket mer för en bättre vardag"
                  id="career.features.list-more"
                  key="10"
                />,
              ]}
              lastIsSeeMore
            />
          }
          subTitle={
            <FormattedMessage
              defaultMessage="Du kommer njuta lite&nbsp;extra"
              id="career.features.room-for-everyone-subtitle"
            />
          }
          title={
            <FormattedMessage
              defaultMessage="Allt&nbsp;du&nbsp;behöver. Och&nbsp;mycket&nbsp;mer."
              id="career.features.room-for-everyone-title"
            />
          }
        />
      </Column>
      <Column limitWidth>
        <Gallery />
      </Column>
    </Row>

    <Row top="second">
      <Column first>
        <img alt="Thumbs up!" src={imgThumbsUp} style={{ marginBottom: '-50px' }} />
      </Column>
      <Column limitWidth>
        <Textblock
          description={
            <FormattedHTMLMessage
              defaultMessage="Du kommer trivas med oss i vårt <span class='hidden-xs'>hög-<br />presterande</span><span class='visible-xs'>högpresterande</span> team. Tillsammans hjälps vi åt att&nbsp;nå mål snabbare och smartare än andra. När&nbsp;vi&nbsp;gör det, då firar vi vår framgång och våra framsteg!"
              id="career.features.aim-description"
            />
          }
          subTitle={
            <FormattedHTMLMessage
              defaultMessage="<span class='hidden-xs'>Du kommer nå högre mål än tidigare</span><span class='visible-xs'>Du kommer nå mål du inte trodde var möjligt</span>"
              id="career.features.aim-subtitle"
            />
          }
          title={
            <FormattedMessage defaultMessage="Vi siktar högt. Och gör det smart." id="career.features.aim-title" />
          }
        />
      </Column>
    </Row>
    <DoodleBackground className={styles.doodleBg} variant="topLeft" />
  </div>
)

export default Features
